import { render, staticRenderFns } from "./BadOrder.vue?vue&type=template&id=7db2ec33&scoped=true&"
import script from "./BadOrder.vue?vue&type=script&lang=js&"
export * from "./BadOrder.vue?vue&type=script&lang=js&"
import style0 from "./BadOrder.vue?vue&type=style&index=0&id=7db2ec33&lang=less&scoped=true&"
import style1 from "./BadOrder.vue?vue&type=style&index=1&id=7db2ec33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db2ec33",
  null
  
)

export default component.exports